import { Select } from 'antd';

import { AssignmentFilters } from 'features/assignment/AssignmentsFilter';
import { AssignmentFilterTypes } from 'features/assignment/enums';
import { getAssignmentStatusOptions } from 'utils/assignmentUtils';

type Props = {
  filters: AssignmentFilters;
  onChange: (data: AssignmentFilters) => void;
};

export default function AssignmentStatusFilter(props: Props) {
  const { filters, onChange } = props;

  const handleFilterChange =
    (type: AssignmentFilterTypes) => (statuses: number[]) => {
      onChange({
        ...filters,
        [type]: statuses,
      });
    };

  return (
    <Select
      className="full-width"
      value={filters[AssignmentFilterTypes.Status]}
      mode="multiple"
      optionFilterProp="children"
      placeholder="Select a status"
      onChange={handleFilterChange(AssignmentFilterTypes.Status)}
      showSearch
      data-id="assignmentStatusFilterField"
      filterOption
    >
      {getAssignmentStatusOptions().map((option) => (
        <Select.Option key={option.value} value={option.value}>
          {option.label}
        </Select.Option>
      ))}
    </Select>
  );
}
